module.exports = __webpack_public_path__ + "static/img/z-7.42c52e5b.png";